import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Logindetail.css";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import copy from "copy-to-clipboard";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import Button from "@mui/material/Button";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import { Box, List, ListItem, ListItemText, TextField, Typography } from "@mui/material";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import Stepperformhead from "./Stepperformhead";
import { useDispatch } from "react-redux";
import { SetUserToken } from "../../../Store/UserTokenSlice";
import { SetAuthToken } from "../../../Store/ApiAuthKey";
import logoimage from '../Asset/New_Assert/ESO_Logo.png';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import LogoutIcon from '@mui/icons-material/Logout';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import Loader from "../CommonLoader";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import UserActivityTracker from "../../../hooks/userActivityTracker";



function Domainownership() {
  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState("");
  const [apiopen, setapiOpen] = React.useState(false);
  const [apisuccessopen, setapisuccessopen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [apiOpen, setApiOpen] = useState(false);
  const [apiErrorMsg, setApiErrorMsg] = useState("");
  const [toggle, setToggle] = useState(false);
  const [faqData, setfaqData] = useState("2")
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [userdomainid, setUserdomainid] = useState("")
  const [isExistingEmail, setIsExistingEmail] = useState('');
  const [businessEmail, setBusinessEmail] = useState(null);
  const [businessEmailError, setBusinessEmailError] = useState(null);
  const [otpEnable, setOtpEnable] = useState(false);
  const [otp, setOtp] = useState(null);
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
  const [verification_method, setVerification_method] = useState('txt');

  const dispatch = useDispatch();
  const verifyMethod = localStorage.getItem('verification_method');

  const apihandleClose = () => {
    setapiOpen(false);
  };
  const apisuccesshandleClose = () => {
    setapisuccessopen(false);
    navigate('/Googleanalytics')
  }

  const closeSuccessPopup = () => {
    setOpenSuccessPopup(false);
  }

  useEffect(() => {
    if (verifyMethod && verifyMethod !== 'undefined') {
      setVerification_method(verifyMethod);
    }
    if (esodata.domaindata.value.header_selected != 'undefined' && esodata.domaindata.value.header_selected != "") {
      setUserdomainid(esodata.domaindata.value.header_selected)
      callUserdataApi(esodata.domaindata.value.header_selected);
    }
    else
      GetuserDatavalue();

  }, []);
  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)

        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data) {
        setUserdomainid(datavalue?.data?.user_domain_id_for_domain_domain_ownership_required)
        callUserdataApi(datavalue?.data?.user_domain_id_for_domain_domain_ownership_required)
      }

    } catch (err) {
      console.log(err);
    }
  };
  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=50`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  useEffect(() => {
    faqdatafun()
  }, []);
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };
  const nextButtonClick = async () => {

    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/ownership_token_verify/?user_domain_id=${userdomainid}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
          return false;
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data?.status_code == 200) {
        setapisuccessopen(true);
        setapierrorMsg(datavalue?.data?.message)
      }
    } catch (err) {

      if (err.response.data.status_code === 408) {


        toast.error(err.response.data.error, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        setTimeout(() => {
          window.location.reload();
        }, 2000);


      }
      else {

        toast.error(err.response.data.error, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

      }

    }



  }
  const handleCopyClick = () => {
    copy(text);
    toast.success('Successfully copied to clipboard', {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };
  const callUserdataApi = async (jobid = "") => {
    setLoading(true);
    try {
      const domain_owber = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/ownership_token_generate/?user_domain_id=${jobid}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      setText(domain_owber?.data?.domain_verification_token)

    } catch (err) { }
    setLoading(false);
  };

  const TriggerLogout = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/logout/`,
        {
          headers: {
            Authorization: `Token ${ApiToken}`,
          },
        }
      );

      if (datavalue.data) {

        localStorage.setItem("eso_auth_token", "");
        localStorage.setItem("eso_user_token", "");
        dispatch(SetUserToken({ eso_user_token: "" }));
        dispatch(SetAuthToken({ eso_auth_token: "" }));
        localStorage.clear()
        navigate("/login");
      }
    } catch (err) {
      localStorage.setItem("eso_auth_token", "");
      localStorage.setItem("eso_user_token", "");
      dispatch(SetUserToken({ eso_user_token: "" }));
      dispatch(SetAuthToken({ eso_auth_token: "" }))
      localStorage.clear()
      navigate("/login");
    }
  };

  const sendOtp = async () => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(businessEmail)) {
      setBusinessEmailError(true);
      return;
    } else {
      setBusinessEmailError(false);
    }
    setLoading(true);
    try {
      const datavalue = await axios.post(
        `${process.env.REACT_APP_API_URL}domain/domain_verification_using_email_send_otp/`,
        {
          user_domain_id: userdomainid,
          business_email: businessEmail
        },
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data && datavalue?.data.message === 'OTP sent to your email!') {
        setOtpEnable(true);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }

  const verifyOtp = async () => {
    setLoading(true);
    try {
      const datavalue = await axios.post(
        `${process.env.REACT_APP_API_URL}domain/domain_verification_using_email_verify_otp/`,
        {
          user_domain_id: userdomainid,
          otp: otp
        },
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      console.log('datavalue?.data.message', datavalue?.data.message);
      if (datavalue?.data && datavalue?.data.message === 'Domain verified successfully!') {
        navigate('/Googleanalytics');
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }

  const checkExistingEmail = async () => {
    setLoading(true);
    try {
      const datavalue = await axios.post(
        `${process.env.REACT_APP_API_URL}domain/domain_verification_using_email/`,
        {
          user_domain_id: parseInt(userdomainid)
        },
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error);
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data && datavalue?.data.message === 'Domain verified successfully!') {
        navigate('/Googleanalytics');
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }

  const skipButtonclick = () => {
    navigate('/')
  }

  return (
    <div className="userdata">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {loading === true ? <Loader /> : null}

      <div className="header_wrap" style={{ background: "#fff" }}>
        <div className="header_inner_top_wrap">
          <div className="drp_outer_wrap">
            <div class="Logo_wrap1">
              <img src={logoimage} alt="ESO Logo" class="Siteimage" style={{ width: "160px" }}></img>
            </div>
          </div>
        </div>
        <div className="header_inner_btm_wrap" style={{ gap: "5px" }}>
          <div className="bell-container top_icons_grp" >
            <span className="account_set_wrap">
              <button style={{ background: "#fff" }}
                onClick={handleToggle}
                title="Frequently Asked Question">
                <QuestionMarkIcon />
              </button>
            </span>
          </div>
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
          <div className="bell-container top_icons_grp" >
            <span className="account_set_wrap">
              <button style={{ background: "#fff" }}
                onClick={TriggerLogout}
                title="Logout">
                <LogoutIcon />
              </button>
            </span>
          </div>
        </div>
      </div>

      {/* <div className="cnt_hdr_top_rgt_wrap" style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "10px", background: "#fff", position: "fixed", zIndex: 999 }}>
        <img
          className="Eso_logo"
          src={logoimage}
          alt="logo"
          style={{ width: "14%", background: "#fff" }}
        />

        <div style={{ display: "flex", alignItems: "center", gap: "10px", paddingRight: "20px" }}>
          <button
            onClick={handleToggle}
            className="faq_class"
            title="Frequently Asked Question"
            style={{ padding: "8px 13px 8px 7px" }}
          >
            <QuestionMarkIcon />
          </button>

          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

          <button onClick={TriggerLogout}>
            <span
              className="material-icons"
              title="Logout"
              style={{ marginLeft: '5px', padding: "10px 8px 10px 0px" }}
            >
              <LogoutIcon />
            </span>
          </button>
        </div>
      </div> */}
      <Stepperformhead setActiveStep={3} />
      <div className="outer-container1"
      >
        {verification_method === 'txt' &&
          // {true &&
          <div className="userdata_inner">
            <h1>Verify Your Website Ownership</h1>

            <div className="form-group domain_owner domain_ownertext">

              <div className="domain-ownership">
                <label><b>1. </b>Sign in to your domain name provider (e.g., godaddy.com or namecheap.com)</label>
              </div>
              <div className="domain-ownership">
                <label><b>2. </b>Copy the TXT record below into the DNS configuration for your website</label>
              </div>
              <div className="domain-ownership">
                <label><b>3. </b>Press the Next button below</label>
              </div>

            </div>

            <div style={{ display: "flex", marginLeft: "13%" }}>
              <label>TXT Record</label>
            </div>
            <div class="form-group domain_owner domain_ownertext domain_input_row">

              <TextField
                variant="outlined"
                value={text}
                onChange={(e) => setText(e.target.value)}
                disabled
                sx={{ width: '58%', border: "1px solid #ff601f", borderRadius: "4px" }}
              />

              <button className="copybutton" onClick={handleCopyClick}>
                Copy
                <span className="material-icons" style={{ marginLeft: '5px' }}>{<ContentCopyIcon />}</span>
              </button>

            </div>




            <div className="domainownership">
              Note: Usually, after changing the TXT record, it will take effect only after 60 secs. This token will expire in 7 days
            </div>

            <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/Domaindata")}
                sx={{
                  padding: "10px 10px",
                  borderRadius: "4px",
                  fontSize: "16px",
                  backgroundColor: "#ff601f",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#ffdfd2", color: "#ff601f" },
                }}
              >
                <div style={{ display: "contents" }}>
                  <span>Back</span><FastRewindIcon />
                </div>
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={nextButtonClick}

                sx={{
                  marginLeft: "50px",
                  padding: "10px 15px",
                  borderRadius: "10px",
                  fontSize: "16px",
                  backgroundColor: "#ff601f",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#ff601f",
                  },
                }}
              >
                <div style={{ display: "contents" }}>
                  <span>Next</span><FastForwardIcon />
                </div>
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => { navigate('/') }}

                sx={{
                  marginLeft: "50px",
                  padding: "10px 15px",
                  borderRadius: "10px",
                  fontSize: "16px",
                  backgroundColor: "#ff601f",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#ff601f",
                  },
                }}
              >
                Add It Later
              </Button>
            </Box>

          </div>
        }
        {verification_method === 'email' &&
          // {true &&
          <div className="userdata_inner">
            <h1>Email us from business email account</h1>

            <div className="form-group domain_owner domain_ownertext">

              <div className="domain-ownership">
                <label>Send us an email from your business email address with the following details:</label>
              </div>
              <div className="domain-ownership">
                <label><b>To:</b> contact@elitesiteoptimizer.com</label>
              </div>
              <div className="domain-ownership">
                <label><b>Subject:</b> Verify Domain Request for ESO</label>
              </div>
              <div className="domain-ownership">
                <label><b>Message:</b> I am authorized to verify ownership of the domain <span style={{color: '#ff601f'}}>{'<enter domain here>'}</span> and allow Elite Site Optimizer to crawl my public-facing website for metrics and reporting</label>
              </div>

            </div>
            <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/Domaindata")}
                sx={{
                  padding: "10px 10px",
                  borderRadius: "4px",
                  fontSize: "16px",
                  backgroundColor: "#ff601f",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#ffdfd2", color: "#ff601f" },
                }}
              >
                <div style={{ display: "contents" }}>
                  <span>Back</span><FastRewindIcon />
                </div>
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => { navigate('/') }}

                sx={{
                  marginLeft: "50px",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  fontSize: "16px",
                  backgroundColor: "#ff601f",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#ff601f",
                  },
                }}
              >
                Continue
              </Button>
            </Box>

          </div>
        }



        {/* {verification_method === 'email' && */}
        {false &&
          <div className="userdata_inner">
            <h1>Verify Your Email</h1>
            <div style={{ justifySelf: "center" }}>
              <div>
                <label htmlFor="exist">Do you want to verify your domain using your existing email address:</label>
                <div style={{ marginTop: "3px" }}>
                  <label>
                    <input
                      type="radio"
                      value="yes"
                      checked={isExistingEmail === 'yes'}
                      onChange={(e) => setIsExistingEmail(e.target.value)}
                    />
                    Yes
                  </label>

                  <label style={{ marginLeft: '10px' }}>
                    <input
                      type="radio"
                      value="no"
                      checked={isExistingEmail === 'no'}
                      onChange={(e) => setIsExistingEmail(e.target.value)}
                    />
                    No
                  </label>
                </div>
              </div>
              <div style={{ margin: "20px 0px" }}>
                {isExistingEmail === 'no' &&
                  <div>
                    <div className="campaigns-addedit-row">
                      <div className="keyword-col1-fields">
                        <label>Business Email</label>
                        <div>
                          <input
                            type="text"
                            id="businessEmail"
                            name="businessEmail"
                            title="BusinessEmail"
                            placeholder="Business Email"
                            value={businessEmail}
                            onChange={(e) => setBusinessEmail(e.target.value)}
                            style={{ display: "block", marginTop: "5px" }}
                          />
                        </div>
                        {businessEmailError &&
                          <div>
                            <span className="domain-errordata">Please enter valid email</span>
                          </div>
                        }
                      </div>
                      <div className="keyword-col2-fields" style={{ alignSelf: "self-end" }}>
                        <div>
                          <button
                            className="btn_dashboard"
                            style={{ marginLeft: "auto" }}
                            type="button"
                            onClick={sendOtp}
                          >
                            Send OTP
                          </button>
                        </div>
                      </div>
                    </div>
                    {otpEnable &&
                      <div className="campaigns-addedit-row">
                        <div className="keyword-col1-fields">
                          <label>Verify OTP</label>
                          <div>
                            <input
                              type="text"
                              id="otp"
                              name="otp"
                              title="OTP"
                              placeholder="Enter OTP"
                              value={otp}
                              onChange={(e) => setOtp(e.target.value)}
                              style={{ display: "block", marginTop: "5px" }}
                            />
                          </div>
                        </div>
                        <div className="keyword-col2-fields">
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>

              <Box sx={{ mt: 6, display: "flex", justifyContent: "center", gap: 4 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => navigate("/Domaindata")}
                  sx={{
                    padding: "10px 10px",
                    borderRadius: "4px",
                    fontSize: "16px",
                    backgroundColor: "#ff601f",
                    color: "white",
                    width: "min-content",
                    "&:hover": { backgroundColor: "#ff7d45" },
                  }}
                >
                  <div style={{ display: "contents" }}>
                    <span>Back</span><FastRewindIcon />
                  </div>
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    isExistingEmail === 'yes' ? checkExistingEmail() : verifyOtp();
                  }}
                  sx={{
                    padding: "10px 10px",
                    borderRadius: "4px",
                    fontSize: "16px",
                    backgroundColor: "#ff601f",
                    color: "white",
                    width: "min-content",
                    "&:hover": { backgroundColor: "#ff7d45" },
                  }}
                  disabled={isExistingEmail === 'no' && !otp}
                >

                  <div style={{ display: "contents" }}>
                    <span>Next</span><FastForwardIcon />
                  </div>
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={skipButtonclick}
                  sx={{
                    padding: "10px 10px",
                    borderRadius: "4px",
                    fontSize: "16px",
                    backgroundColor: "#ff601f",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#ffdfd2", color: "#ff601f" },
                  }}
                >
                  Skip
                </Button>
              </Box>
            </div>
          </div>
        }

      </div>
      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={12}>
              <div className="footer-left">
                <p className="footer-text" style={{ textAlign: "center" }}>
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand"> Elite site Optimizer</span>
                  </a>
                </p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Dialog
        open={apiopen}
        onClose={apihandleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "18px !important",
            borderColor: "#ff601f !important",
            top: "10px !important",
            width: '100%',
          },
        }}
      >
        <DialogTitle className="keyword-dialog-header" sx={{ display: 'flex', justifyContent: 'center' }} ><ReportProblemIcon fontSize="large" sx={{ color: '#ff601f' }} /></DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <DialogContentText id="alert-dialog-slide-description">
            {apierrorMsg && apierrorMsg.split('-').length >= 2 ? (
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', lineHeight: '1px', width: "max-content" }}>
                <p>{apierrorMsg.split('-')[0]}</p>
                <p>{apierrorMsg.split('-')[1]}</p>
              </div>
            ) : (
              <p>{apierrorMsg}</p>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button" sx={{ justifyContent: 'center' }}>
          <Button onClick={apihandleClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <CommonErrorAlert
        data={{
          apiopen: apisuccessopen,
          apiErrorMsg: apierrorMsg,
          isIconStyled: true
        }}
        closeAlert={apisuccesshandleClose} />
      <CommonErrorAlert
        data={{
          apiopen: openSuccessPopup,
          apiErrorMsg: 'Domain verified successfully!',
          isIconStyled: false
        }}
        closeAlert={closeSuccessPopup} />
      <UserActivityTracker pagename="Onboarding - Domain Ownership" />
    </div >

  );
}

export default Domainownership;


